import React, { useState } from "react";
import "./ThirdSection.css";
import CareerForm from "./CareerForm/CareerForm";

const ThirdSection = () => {

  const [showForm, setShowForm] = useState(false);

  const [selectedDesignation, setSelectedDesignation]
  = useState("");

  const openForm = (designation) => {

    setSelectedDesignation(designation);

    setShowForm(true);

  };

  return (

    <section className="third-section">

      <div className="third-container">

        <div className="third-top">

          <h2>Join Our Team</h2>

          <p>
            Build Your Career With Fidin Construction
          </p>

        </div>

        <div className="career-grid">

          <div className="career-card">

            <div className="career-icon">🚀</div>

            <h3>Growth Opportunities</h3>

            <p>
              Work on cutting-edge solar & infrastructure projects.
            </p>

          </div>

          <div className="career-card">

            <div className="career-icon">💼</div>

            <h3>Great Work Culture</h3>

            <p>
              Collaborative environment and work-life balance.
            </p>

          </div>

          <div className="career-card">

            <div className="career-icon">🎯</div>

            <h3>Impactful Projects</h3>

            <p>
              Build sustainable infrastructure for the future.
            </p>

          </div>

        </div>

        <div className="jobs-section">

          <h3>Current Openings</h3>

          {/* JOB 1 */}

          <div className="job-card">

            <div>

              <h4>Site Engineer - Solar Projects</h4>

              <p>📍 PUNE | Full Time | 2-5 Years Exp</p>

            </div>

            <button
              onClick={() =>
                openForm("Site Engineer - Solar Projects")
              }
            >
              Apply Now
            </button>

          </div>

          {/* JOB 2 */}

          <div className="job-card">

            <div>

              <h4>Electrical Engineer - T&D</h4>

              <p>📍 Cuttack | Full Time | 3-6 Years Exp</p>

            </div>

            <button
              onClick={() =>
                openForm("Electrical Engineer - T&D")
              }
            >
              Apply Now
            </button>

          </div>

          {/* JOB 3 */}

          <div className="job-card">

            <div>

              <h4>Project Manager</h4>

              <p>📍 Bhanjanagar | Full Time | 5+ Years Exp</p>

            </div>

            <button
              onClick={() =>
                openForm("Project Manager")
              }
            >
              Apply Now
            </button>

          </div>

          <div className="career-mail">

            Didn't find a suitable role? Send your
            resume to

            <a href="mailto:careers@fidinventures.com">
              careers@fidinventures.com
            </a>

          </div>

        </div>

      </div>

      {showForm && (

        <CareerForm
          designation={selectedDesignation}
          closeForm={() => setShowForm(false)}
        />

      )}

    </section>
  );
};

export default ThirdSection;